import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';

import Navbar  from './Components/Navbar';
import Footer  from './Components/Footer';
import Home     from './Pages/Home';
import About    from './Pages/About';
import Services from './Pages/Services';
import Contact  from './Pages/Contact';

/* Scroll to top on route change */
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname]);
  return null;
};

const AppLayout = () => (
  <>
    <ScrollToTop />
    <Navbar />
    <Routes>
      <Route path="/"         element={<Home />} />
      <Route path="/about"    element={<About />} />
      <Route path="/services" element={<Services />} />
      <Route path="/contact"  element={<Contact />} />
      {/* Fallback */}
      <Route path="*"         element={<Home />} />
    </Routes>
    <Footer />
  </>
);

const App = () => (
  <BrowserRouter>
    <AppLayout />
  </BrowserRouter>
);

export default App;
